'use client';

import { useSelector, useDispatch } from 'react-redux';
import { changeLanguage, setLanguageError, clearLanguageError } from '../redux/slices/languageSlice';
import config from '@/config/config';

export function useLanguage() {
  const dispatch = useDispatch();
  const { language, dictionary, isLoading, error, availableLanguages } = useSelector((state) => state.language);
  
  // Translation function
  const t = (key) => {
    try {
      if (!key) return '';
      
      const keys = key.split('.');
      let value = dictionary;
      
      for (const k of keys) {
        if (value && value[k]) {
          value = value[k];
        } else {
          // If in development, log missing translations
          if (config.NODE_ENV !== 'production') {
            console.warn(`Translation key not found: ${key}`);
          }
          return key; // Return the key if translation is missing
        }
      }
      
      return value;
    } catch (err) {
      // If in development, log errors
      if (config.NODE_ENV !== 'production') {
        console.error('Translation error:', err);
      }
      return key;
    }
  };
  
  const handleChangeLanguage = (newLanguage) => {
    try {
      dispatch(changeLanguage(newLanguage));
    } catch (err) {
      dispatch(setLanguageError(`Failed to change language: ${err.message}`));
    }
  };
  
  return {
    language,
    t,
    changeLanguage: handleChangeLanguage,
    isLoading,
    error,
    clearError: () => dispatch(clearLanguageError()),
    availableLanguages
  };
}
